import { APP_PATH_RULES } from '../constants/application-types.constants'

export const checkConsultAnswers = (estado, consulta, homeData, userRole) => {
  if (
    userRole === 'administrador_prescriptor' &&
    homeData?.['mercado'] !== 'SV' &&
    homeData?.['mercado'] !== 'ES'
  ) {
    return {
      ...consulta,
      estado,
      flowType: 'none',
      mensaje:
        'Actualmente como prescriptores no pueden crear este tipo de solicitudes. Contacte con Acerca en el 900 500 40 o mandanos un mail a canalacerca@nedgia.es y contactaremos contigo.',
    }
  }

  let flowType = 'none'
  for (let key in APP_PATH_RULES) {
    const path = APP_PATH_RULES[key]
    if (path.condition({ homeData, consulta, userRole })) {
      flowType = path.id
      break
    }
  }

  // const canContinueFlow = flowType !== 'none' && empresa.empresa_id && homeData['zona_nedgia']
  // if (!canContinueFlow) {
  //   console.debug('Data does not allow continuation:', homeData, empresa)
  // }

  return {
    ...consulta,
    estado,
    flowType,
    //canContinueFlow,
  }
}
